import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";

import { me as meApi } from "@/lib/api";

/**
 * Owner-only Settings row that deep-links to the CSP violation
 * dashboard at `/admin/csp`.
 *
 * Renders nothing for non-owners so the row doesn't take vertical
 * space in a regular user's Settings screen. The dashboard itself
 * also gates on `require_owner` server-side; this is UI hygiene, not
 * the security boundary.
 */
export default function AdminCspLink() {
  const { t } = useTranslation();
  const [isOwner, setIsOwner] = useState(false);

  useEffect(() => {
    let cancelled = false;
    meApi
      .isOwner()
      .then((r) => {
        if (!cancelled) setIsOwner(!!r?.data?.is_owner);
      })
      .catch(() => {
        /* silently non-owner */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isOwner) return null;

  return (
    <Link
      to="/admin/csp"
      data-testid="admin-csp-link"
      className="flex items-center gap-3 px-5 py-4 hover:bg-parchment transition text-leaf-ink"
    >
      <span className="text-leaf">
        <ShieldAlert className="w-4 h-4" strokeWidth={1.5} />
      </span>
      <span className="flex-1 flex flex-col">
        <span>{t("adminCsp.entryLabel")}</span>
        <span className="text-[11px] text-leaf-mist mt-0.5">{t("adminCsp.entryHint")}</span>
      </span>
      <span className="text-leaf-mist">›</span>
    </Link>
  );
}
